import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/content';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-283" data-mp="pujaxj4imb7s">
      <div className="mx-auto max-w-6xl" data-id="element-284" data-mp="b5wn0t0tob4y">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-285" data-mp="b4vcqqrmrsoa">
          Cosa contiene <em className="text-red-700" data-id="element-286" data-mp="2600oy1wnod2">ARTE PRONTA™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-287" data-mp="23x41v68ywzd">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-288" data-mp="75cobl0lozgp">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-289" data-mp="3tbrqtxfon0zv">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumi" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8" data-id="element-290" data-mp="3ct4l8hn3cruw">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-291" data-mp="3ltawdwvbhfqw" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-292" data-mp="2y2x3k44wrcv9">{item.number}</span>
                <span className="mt-1 font-serif text-3xl leading-none lg:text-2xl" data-id="element-293" data-mp="2adma77pw0kr5">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-294" data-mp="26dll8t55wr5u">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-295" data-mp="ea7s029wrtad">
          <AnimatePresence mode="wait" initial={false} data-id="element-296" data-mp="o2n78rttm3rk">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-297" data-mp="o46p2mv4kmvg">
              <div className="lg:col-span-5" data-id="element-298" data-mp="5cdvorc58zn7">
                <p className="text-sm font-semibold text-red-700" data-id="element-299" data-mp="1bronv2ct4l7x">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-300" data-mp="1gpq5rjyhyeht">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-301" data-mp="318aex051ebp7">{volume.tagline}</p>
                {volume.intro && <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-302" data-mp="2wailu2snojjf">{volume.intro}</p>}
              </div>
              <div className="lg:col-span-7" data-id="element-303" data-mp="2rgxkq1vrn9g0">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-304" data-mp="2mkpddant8kje">Contiene</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-305" data-mp="2hkkx9lqtdrtp">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-306" data-mp="2dipusdx5d8ec">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-307" data-mp="28jmpcsd9905u" />
                      {entry}
                    </li>)}
                </ul>
                {volume.outro && <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-308" data-mp="6t1eh9p8khxy">{volume.outro}</p>}
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-309" data-mp="1u825kloqwzd">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-310" data-mp="2zm8dk8l18qy1">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-311" data-mp="2lnquio62o2mg">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-312" data-mp="2lpl6ve3a2mex">
              Cosa rende ARTE PRONTA™ diverso?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-313" data-mp="2bww02wio9wpx">
              Un intero anno di materiali di Arte — organizzato e pronto da utilizzare.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-314" data-mp="22ykamxtjl4z2">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-315" data-mp="1sybcvfjwjbhk">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-316" data-mp="1szcuy3zc4y8s" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-317" data-mp="1xxeip27phlql">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-318" data-mp="1ece9qqr2n02i">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}